import React from 'react'
import { useState, useContext, useEffect, useRef } from 'react'
import { ArrowLeftOutlined, ArrowRightOutlined, CheckOutlined, QuestionCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Layout, Button, ConfigProvider, List, Avatar, Divider, Skeleton, Select, Input, Modal, Image, Flex, InputNumber, Table, message, Tooltip } from 'antd';
import en_GB from 'antd/locale/en_GB';
import { Outlet, useLocation } from 'react-router-dom';
import Login from '../loginPage/Login';
import { GlobalInfoProvider, GlobalInfoContext } from '../GlobalInfoContext';
import { userApi } from "../api/user/user-api";
import { UserAvatar } from '../components/user/UserAvatar';
import { jumpToLoginPage } from "../lib/browser-utils";
import { labellingApi } from "../api/labelling-api";
import { validateapi } from "../api/validate/validate-api"
import { useNavigate } from 'react-router-dom';
import { usePhotoLocking } from '../hooks/usePhotoLocking';
import Header from '../homePage/Header';

import "./style.css"
import { elements } from 'chart.js';

const BASE_URL = process.env.REACT_APP_BASE_URL;
const { Content, Sider } = Layout;
const savedPhotoDict = {};
const selectedLabeller = {};

export default function Validation() {
    const navigate = useNavigate();
    const goHomePage = () => {
        //先解锁
        unlockPhoto();
        navigate("/");
    };

    const globalInfo = useContext(GlobalInfoContext);
    if (globalInfo.user.email == "") {
        jumpToLoginPage();
    }

    const { lockedPhotos, lockPhoto, unlockPhoto } = usePhotoLocking(globalInfo, 1);
    const [collapsed, setCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [imageNum, setImageNum] = useState();
    const [gspActiveButton, setGspActiveButton] = useState(null);
    const [gspVisibleButton, setGspVisibleButton] = useState(null);
    const [visibleNum, setVisibleNum] = useState(100);
    const [bandedNum, setBandedNum] = useState(0);
    const [gspNumActiveButton, setGspNumActiveButton] = useState(null);
    const [comments, setComments] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [submitTitle, setSubmitTitle] = useState(false);
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const [selectedPhotoIndex, setSelectedPhotoIndex] = useState(0);
    const [scrollableTarget, setScrollableTarget] = useState(null);
    const [saving, setSaving] = useState(false);
    const [isShowAgeExamples, setIsShowAgeExamples] = useState(false);
    const [isShowBandedExamples, setIsShowBandedExamples] = useState(false);
    const [ageExamplesSex, setAgeExamplesSex] = useState('m');

    const [isShowWarning, setIsShowWarning] = useState(false);
    const [isGspActiveButtonWarning, setIsGspActiveButtonWarning] = useState(false);
    const [isGspVisibleButtonWarning, setIsGspVisibleButtonWarning] = useState(false);
    const [isGspNumActiveButtonWarning, setIsGspNumActiveButtonWarning] = useState(false);
    const [firstJumpWarning, setFirstJumpWarning] = useState(null);

    const [buttonStates, setButtonStates] = useState([]);
    const [gspStates, setGspStates] = useState([]);
    const [warningList, setWarningList] = useState([]);

    const [bandedWarning, setBandedWarning] = useState('');
    const [showBandedWarning, setShowBandedWarning] = useState(false);

    const [showLabelling, setShowLabelling] = useState(false);
    const [tableData, setTableData] = useState([]);

    let currentPhoto = null;

    const leftUpperColorOptions = [
        { value: ['#FFFFFF01', '#FFFFFF01'], label: 'None' },
        { value: ['#FFFFFF02', '#FFFFFF02'], label: 'Unsure' },
        { value: ['#FFFFFF03', '#FFFFFF03'], label: 'Not Visible' },
        { value: ['blue', 'blue'], label: 'Blue' },
        { value: ['green', 'green'], label: 'Green' },
        { value: ['black', 'black'], label: 'Black' },
        { value: ['orange', 'orange'], label: 'Orange' },
        { value: ['purple', 'purple'], label: 'Purple' },
        { value: ['red', 'red'], label: 'Red' },
        { value: ['white', 'white'], label: 'White' },
        { value: ['yellow', 'yellow'], label: 'Yellow' },
    ];

    const leftLowerColorOptions = [
        { value: ['#FFFFFF01', '#FFFFFF01'], label: 'None' },
        { value: ['#FFFFFF02', '#FFFFFF02'], label: 'Unsure' },
        { value: ['#FFFFFF03', '#FFFFFF03'], label: 'Not Visible' },
        { value: ['gold', 'gold'], label: 'Gold' },
        { value: ['blue', 'blue'], label: 'Blue' },
        { value: ['blue', '#c2c5cc'], label: 'Blue Metal' },
        { value: ['brown', 'brown'], label: 'Brown' },
        { value: ['green', 'green'], label: 'Green' },
        { value: ['green', '#c2c5cc'], label: 'Green Metal' },
        { value: ['lime', 'lime'], label: 'Lime' },
        { value: ['#c2c5cc', '#c2c5cc'], label: 'Metal' },
        { value: ['#c2c5cc', 'blue'], label: 'Metal Blue' },
        { value: ['#c2c5cc', 'green'], label: 'Metal Green' },
        { value: ['#c2c5cc', 'black'], label: 'Metal Black' },
        { value: ['#c2c5cc', 'purple'], label: 'Metal Purple' },
        { value: ['black', 'black'], label: 'Black' },
        { value: ['black', '#c2c5cc'], label: 'Black Metal' },
        { value: ['orange', 'orange'], label: 'Orange' },
        { value: ['purple', 'purple'], label: 'Purple' },
        { value: ['red', 'red'], label: 'Red' },
        { value: ['red', 'yellow'], label: 'Red Yellow' },
        { value: ['white', 'white'], label: 'White' },
        { value: ['yellow', 'yellow'], label: 'Yellow' },
    ];

    const rightUpperColorOptions = [
        { value: ['#FFFFFF01', '#FFFFFF01'], label: 'None' },
        { value: ['#FFFFFF02', '#FFFFFF02'], label: 'Unsure' },
        { value: ['#FFFFFF03', '#FFFFFF03'], label: 'Not Visible' },
        { value: ['blue', 'blue'], label: 'Blue' },
        { value: ['brown', 'brown'], label: 'Brown' },
        { value: ['green', 'green'], label: 'Green' },
        { value: ['black', 'black'], label: 'Black' },
        { value: ['orange', 'orange'], label: 'Orange' },
        { value: ['purple', 'purple'], label: 'Purple' },
        { value: ['red', 'red'], label: 'Red' },
        { value: ['white', 'white'], label: 'White' },
        { value: ['yellow', 'yellow'], label: 'Yellow' },
    ];

    const rightLowerColorOptions = [
        { value: ['#FFFFFF01', '#FFFFFF01'], label: 'None' },
        { value: ['#FFFFFF02', '#FFFFFF02'], label: 'Unsure' },
        { value: ['#FFFFFF03', '#FFFFFF03'], label: 'Not Visible' },
        { value: ['gold', 'gold'], label: 'Gold' },
        { value: ['blue', 'blue'], label: 'Blue' },
        { value: ['blue', '#c2c5cc'], label: 'Blue Metal' },
        { value: ['green', 'green'], label: 'Green' },
        { value: ['green', '#c2c5cc'], label: 'Green Metal' },
        { value: ['lime', 'lime'], label: 'Lime' },
        { value: ['#c2c5cc', '#c2c5cc'], label: 'Metal' },
        { value: ['#c2c5cc', 'green'], label: 'Metal Green' },
        { value: ['#c2c5cc', 'black'], label: 'Metal Black' },
        { value: ['#c2c5cc', 'purple'], label: 'Metal Purple' },
        { value: ['#c2c5cc', 'blue'], label: 'Metal Blue' },
        { value: ['black', 'black'], label: 'Black' },
        { value: ['black', '#c2c5cc'], label: 'Black Metal' },
        { value: ['orange', 'orange'], label: 'Orange' },
        { value: ['purple', 'purple'], label: 'Purple' },
        { value: ['purple', '#c2c5cc'], label: 'Purple Metal' },
        { value: ['red', 'red'], label: 'Red' },
        { value: ['#708090', '#708090'], label: 'Slate' },
        { value: ['white', 'white'], label: 'White' },
        { value: ['yellow', 'yellow'], label: 'Yellow' },
    ];

    const colorConstraints = [
        ['None', 'Gold', 'None', 'Metal'],
        ['None', 'Gold', 'None', 'Red'],
        ['None', 'Blue', 'None', 'Metal'],
        ['None', 'Blue Metal', 'None', 'Metal'],
        ['None', 'Blue Metal', 'None', 'Red'],
        ['None', 'Blue', 'None', 'Red'],
        ['None', 'Blue', 'None', 'Yellow'],
        ['Brown', 'Black', 'None', 'Metal'],
        ['Brown', 'Red', 'None', 'Metal'],
        ['Brown', 'White', 'None', 'Metal'],
        ['None', 'Green', 'None', 'Lime'],
        ['None', 'Green', 'None', 'Metal'],
        ['None', 'Green Metal', 'None', 'Metal'],
        ['None', 'Green', 'None', 'Black'],
        ['None', 'Green', 'None', 'Red'],
        ['None', 'Green', 'None', 'Yellow'],
        ['None', 'Lime', 'None', 'Metal'],
        ['None', 'None', 'None', 'Red'],
        ['None', 'Lime', 'None', 'Red'],
        ['None', 'Metal', 'None', 'Gold'],
        ['None', 'Metal', 'None', 'Blue'],
        ['None', 'Metal', 'Blue', 'Blue'],
        ['None', 'Metal', 'None', 'Blue Metal'],
        ['None', 'Metal', 'None', 'Green'],
        ['None', 'Metal', 'Green', 'Green'],
        ['None', 'Metal', 'None', 'Green Metal'],
        ['None', 'Metal Green', 'None', 'Metal'],
        ['None', 'Metal', 'Green', 'Black'],
        ['None', 'Metal', 'None', 'Metal'],
        ['None', 'Metal', 'None', 'Metal Blue'],
        ['None', 'Metal', 'None', 'Metal Green'],
        ['None', 'Metal', 'None', 'Metal Black'],
        ['None', 'Metal', 'None', 'Black'],
        ['None', 'Metal Black', 'None', 'Metal'],
        ['None', 'Metal', 'Black', 'Black'],
        ['None', 'Metal', 'Orange', 'Blue'],
        ['None', 'Metal', 'Orange', 'Orange'],
        ['None', 'Metal', 'None', 'Purple'],
        ['None', 'Metal Purple', 'None', 'Metal'],
        ['None', 'Metal', 'Red', 'Purple'],
        ['None', 'Metal', 'Red', 'Red'],
        ['None', 'Metal', 'None', 'White'],
        ['None', 'Metal', 'None', 'Yellow'],
        ['None', 'Metal', 'Yellow', 'Brown'],
        ['None', 'Metal', 'Yellow', 'Black'],
        ['None', 'Metal', 'Yellow', 'Orange'],
        ['None', 'Metal', 'Yellow', 'Red'],
        ['None', 'Metal', 'Yellow', 'White'],
        ['None', 'Black', 'None', 'Gold'],
        ['None', 'Black', 'None', 'Blue'],
        ['None', 'Black', 'None', 'Green'],
        ['None', 'Black', 'None', 'Lime'],
        ['None', 'Black', 'None', 'Metal'],
        ['Black', 'Black', 'None', 'Metal'],
        ['None', 'Black', 'None', 'Red'],
        ['None', 'Black', 'None', 'Red'],
        ['None', 'Black', 'None', 'White'],
        ['None', 'Black', 'None', 'Yellow'],
        ['Black', 'Yellow', 'None', 'Metal'],
        ['Orange', 'White', 'None', 'Metal'],
        ['Orange', 'Yellow', 'None', 'Metal'],
        ['None', 'Purple', 'None', 'Metal'],
        ['None', 'Purple Metal', 'None', 'Metal'],
        ['None', 'Purple Metal', 'None', 'Red'],
        ['None', 'Purple', 'None', 'Red'],
        ['None', 'Red', 'None', 'Gold'],
        ['None', 'Red', 'None', 'Blue'],
        ['None', 'Red', 'None', 'Blue Metal'],
        ['None', 'Red', 'None', 'Green'],
        ['None', 'Red', 'None', 'Metal'],
        ['None', 'Red', 'None', 'Metal Purple'],
        ['None', 'Red', 'None', 'Black'],
        ['None', 'Red', 'None', 'Purple'],
        ['None', 'Red', 'None', 'Red'],
        ['Red', 'Red', 'None', 'Metal'],
        ['None', 'Red', 'None', 'White'],
        ['None', 'Red', 'None', 'Yellow'],
        ['Red', 'Yellow', 'None', 'Metal'],
        ['None', 'Slate', 'None', 'Yellow'],
        ['White', 'Orange', 'None', 'Metal'],
        ['None', 'White', 'None', 'Red'],
        ['White', 'Red', 'None', 'Metal'],
        ['None', 'White', 'None', 'Yellow'],
        ['White', 'Yellow', 'None', 'Metal'],
        ['None', 'Yellow', 'None', 'Green'],
        ['None', 'Yellow', 'None', 'Metal'],
        ['None', 'Yellow', 'None', 'Black'],
        ['Yellow', 'Orange', 'None', 'Metal'],
        ['None', 'Yellow', 'None', 'Red'],
        ['Yellow', 'Red', 'None', 'Metal'],
        ['None', 'Yellow', 'None', 'White'],
        ['Yellow', 'White', 'None', 'Metal'],
        ['Yellow', 'White', 'None', 'Metal'],
        ['None', 'Yellow', 'None', 'Yellow'],
        ['Yellow', 'Yellow', 'None', 'Metal'],
        ['Orange', 'Red', 'None', 'Metal'],
        ['Black', 'Red', 'None', 'Metal'],
        ['Brown', 'Orange', 'None', 'Metal'],
        ['Red', 'Orange', 'None', 'Metal'],
        ['Orange', 'Orange', 'None', 'Metal'],
        ['Yellow', 'Black', 'None', 'Metal'],
        ['Black', 'Orange', 'None', 'Metal'],
        ['White', 'Black', 'None', 'Metal'],
        ['Orange', 'Black', 'None', 'Metal'],
    ];

    const scrollToTop = (anchorName) => {
        if (anchorName) {
            const anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                document.getElementById('label-sider').scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }

    const scrollToId = (anchorName) => {
        if (anchorName) {
            const anchorElement = document.getElementById(anchorName);
            if (anchorElement) {
                anchorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
    }

    useEffect(() => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            for (let i = prevState.length; i < bandedNum; i++) {
                newState.push({
                    sex: null,
                    age: null,
                    rightUpper: null,
                    rightLower: null,
                    leftUpper: null,
                    leftLower: null,
                });
            }
            return newState.slice(0, bandedNum);
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            for (let i = prevState.length; i < bandedNum; i++) {
                newState.push({
                    sex: null,
                    age: null,
                    rightUpper: null,
                    rightLower: null,
                    leftUpper: null,
                    leftLower: null,
                });
            }
            return newState.slice(0, bandedNum);
        });
    }, [bandedNum, buttonStates.length]);

    useEffect(() => {
        if (globalInfo.user.userRole) {
            loadMoreData();
        }
    }, [globalInfo.user.userRole]);

    useEffect(() => {
        if (globalInfo.user.userRole) {
            validateapi.getImageNum({
                status: "pending"
            }).then((body) => {
                setImageNum(body);
            })
            // labellingApi.getImageNum({
            //     status: "unlabelled"
            // }).then((body) => {
            //     setImageNum(body);
            // })
        }
    }, [globalInfo.user.userRole])

    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
    };

    const location = useLocation();
    if (location.pathname === '/login') {
        return <Login></Login>
    }

    const loadMoreData = () => {
        if (loading) {
            return;
        }
        validateapi.getImageNum({
            status: "pending"
        }).then((body) => {
            setImageNum(body);
        })
        setLoading(true);
        validateapi.getPage(
            {
                pageNum: currentPage,
                pageSize: pageSize,
                status: "pending"
            }
        )
            .then((body) => {
                // Handle the new data format where each item is an array of two objects
                const processedData = body.map(item => {
                    // Each item is now an array of objects
                    // We'll use the first object as our main data
                    const mainItem = item[0];
                    // Store all labellings in a property for display in the table
                    mainItem.allLabellings = item;
                    return mainItem;
                });

                const seenFileNames = new Set();
                const uniqueBody = processedData.filter(item => {
                    if (seenFileNames.has(item.fileName)) {
                        return false;
                    } else {
                        seenFileNames.add(item.fileName);
                        return true;
                    }
                });

                const newItems = uniqueBody.filter(item =>
                    !data.some(existingItem => existingItem.fileName === item.fileName)
                );

                setData([...data, ...newItems]);
                setCurrentPage(currentPage + 1);
                setLoading(false);

                // 检查是否有未标注的照片
                const pendingPhotos = [...data, ...newItems].filter(item => item.validateFlag !== "Y");
                if (pendingPhotos.length === 0) {
                    // 如果所有照片都已标注，清空选中的照片和相关状态
                    setSelectedPhoto(null);
                    currentPhoto = null;
                    setTableData([]);
                    setShowLabelling(false);
                    return;
                }

                if (!selectedPhoto && processedData.length > 0) {
                    labellingApi.getLockedPhotos({ status: 1 }).then((lockedInfo) => {
                        // 找到第一张未标注的照片,且未被锁定
                        const selectIndex = 0;
                        const firstPendingPhoto = pendingPhotos.slice(selectIndex)
                            .find(photo => (typeof (lockedInfo) == 'undefined' || lockedInfo.length <= 0 || typeof (lockedInfo[photo.photoId]) == 'undefined' || (String(lockedInfo[photo.photoId]) == String(globalInfo.user.userId))))
                        if (firstPendingPhoto) {
                            const photoIndex = pendingPhotos.indexOf(firstPendingPhoto);
                            setSelectedPhoto(firstPendingPhoto);
                            setSelectedPhotoIndex(photoIndex);
                            currentPhoto = firstPendingPhoto;
                            getTableData(currentPhoto);
                            lockPhoto(firstPendingPhoto.photoId);
                        }
                    });
                }
            })
            .catch(() => {
                setLoading(false);
            });
    };

    //检查照片是否上锁
    const checkPhotoLock = (photoId) => {
        const isLockedByOther = lockedPhotos[photoId] && String(lockedPhotos[photoId]) !== String(globalInfo.user.userId);
        if (isLockedByOther) {
            return false;
        }
        return true;
    }

    const handlePhotoClick = (photo) => {
        if (!photo) return;
        // 检查照片是否上锁
        if (checkPhotoLock(photo.photoId)) {
            lockPhoto(photo.photoId);
        } else {
            return;
        }
        setSelectedPhoto(photo);
        if (photo && !(photo.fileName in savedPhotoDict) && !photo.hasAnimal) {
            photo.hasAnimal = 'N';
        }
        currentPhoto = photo;
        clearButton(true);
        setShowLabelling(false);
        setSaving(false); // 重置saving状态，确保点击照片后按钮不会处于loading状态
        scrollToTop("label-sider");
        getTableData(currentPhoto);
    };

    const gspHandleClick = (buttonId, hasAnimal) => {
        if (hasAnimal === 'N') {
            var oldComments = comments;
            clearButton(true);
            setComments(oldComments);
            setSelectedPhoto(data[selectedPhotoIndex]);
            if (selectedPhoto) {
                selectedPhoto.num = 0;
            }
        }
        if (selectedPhoto) {
            selectedPhoto.hasAnimal = hasAnimal;
        }
        setGspActiveButton(buttonId);
    };

    const answerCorrectClick = (correct) => {
        selectedLabeller[selectedPhoto.fileName] = correct
        if (correct === 'N') {
            setShowLabelling(true);
        } else {
            saveCorrectAnswer();
        }
    };

    const gspVisibleClick = (buttonId, num) => {
        setGspVisibleButton(buttonId);
        setVisibleNum(num);
        if (selectedPhoto) {
            selectedPhoto.visibleNum = num;
            if (num < bandedNum) {
                setBandedNum(0);
                gspNumHandleClick('button_num_0', 0);
            }
        }
    };

    const setGspClick = (buttonId, hasAnimal) => {
        if (hasAnimal === 'N') {
            var oldComments = comments;
            clearButton(false);
            setComments(oldComments);
            setSelectedPhoto(data[selectedPhotoIndex]);
        }
        if (selectedPhoto) {
            selectedPhoto.hasAnimal = hasAnimal;
        }
        setGspActiveButton(buttonId);
    };

    const gspNumHandleClick = (buttonId, num) => {
        if (num === 0) {
            var oldComments = comments;
            var oldHasAnimal = selectedPhoto?.hasAnimal;
            var oldVisibleNum = selectedPhoto?.visibleNum;
            clearButtonAfterBandedChose0();
            setComments(oldComments);
            setSelectedPhoto(data[selectedPhotoIndex]);
            if (selectedPhoto) {
                selectedPhoto.hasAnimal = oldHasAnimal;
                selectedPhoto.visibleNum = oldVisibleNum;
            }
        }
        if (selectedPhoto) {
            selectedPhoto.num = num;
        }
        setBandedNum(num);
        setGspNumActiveButton(buttonId);
    };

    const gspAgeHandleClick = (buttonId, age, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].age = buttonId;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].age = age;
            return newState;
        });
    };

    const gspSexHandleClick = (buttonId, sex, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].sex = buttonId;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].sex = sex;
            return newState;
        });
        if (sex !== 'unknown') {
            setAgeExamplesSex(sex);
        }
    };

    const clearButtonAfterBandedChose0 = () => {
        setButtonStates([]);
        setBandedNum(0);
        setGspStates([]);
    }

    const clearButton = (isShowSavedPhoto) => {
        setGspActiveButton(null);
        setGspVisibleButton(null);
        setVisibleNum(100);
        setGspNumActiveButton(null);
        clearButtonAfterBandedChose0();

        setComments('');
        if (isShowSavedPhoto) {
            showSavedPhoto();
        }
    }

    const setButton = (photo) => {
        if (!photo || photo.length < 3 || !photo[0]) {
            return;
        }

        if (photo[3] === "correct") {
            return;
        }
        setButtonStates(photo[1])
        setGspStates(photo[2])
        if (photo[0].hasAnimal == null) {
            setGspActiveButton(null);
        } else {
            if (photo[0].hasAnimal == 'Y') {
                setGspClick('button_in_y', 'Y');
            } else {
                setGspClick('button_in_n', 'N');
                setComments(photo[0].comments);
                return;
            }
        }

        if (photo[0].visibleNum == null) {
            setVisibleNum(100);
            setGspVisibleButton(null);
        } else {
            clearVisibleButton(photo[0].visibleNum);
        }

        setBandedNum(photo[0].num);
        setGspNumActiveButton('button_num_' + photo[0].num, photo[0].num);

        setComments(photo[0].comments);
    }

    const draftHandleClick = () => {
        setSubmit('Save draft in progress...');
        setIsModalOpen(true);
    };

    const checkButtonClicked = () => {
        var warning = null;
        var showWaring = false;
        if (gspActiveButton === null) {
            setIsGspActiveButtonWarning(true);
            if (warning === null) {
                warning = 'GSP-active';
            }
            showWaring = true;
        }
        if (gspActiveButton === 'button_in_n') {
            return showWaring;
        }
        if (gspVisibleButton === null && visibleNum === null) {
            setIsGspVisibleButtonWarning(true);
            if (warning === null) {
                warning = 'GSP-visible';
            }
            showWaring = true;
        }
        if (gspNumActiveButton === null) {
            setIsGspNumActiveButtonWarning(true);
            if (warning === null) {
                warning = 'GSP-number';
            }
            showWaring = true;
        }

        let tmpWarningList = []
        for (let i = 0; i < bandedNum; i++) {
            if (buttonStates[i].sex === null) {
                tmpWarningList.push('GSP-sex' + (i + 1))
            }
            if (buttonStates[i].age === null) {
                tmpWarningList.push('GSP-age' + (i + 1))
            }
        };

        if (tmpWarningList.length > 0) {
            warning = tmpWarningList[0]
            showWaring = true;
        }
        setWarningList(tmpWarningList);

        if (showWaring) {
            setIsShowWarning(true);
            setFirstJumpWarning(warning);
        }
        return showWaring;
    }

    const clearWarning = () => {
        setIsShowWarning(false);
        setIsGspActiveButtonWarning(false);
        setIsGspVisibleButtonWarning(false);
        setIsGspNumActiveButtonWarning(false);
        setWarningList([]);
        setFirstJumpWarning(null);
    }

    const jumpToWarning = () => {
        scrollToId(firstJumpWarning);
    }

    const isBandedColorCorrect = (colorContent) => {
        var colorList = [colorContent["rightUpper"], colorContent["rightLower"],
        colorContent["leftUpper"], colorContent["leftLower"]].map(item => item === null ? 'None' : item);
        const hasUnsureOrNotVisible = colorList.includes('Unsure') || colorList.includes('Not Visible');
        const isContained = colorConstraints.some((subList) => {
            if (hasUnsureOrNotVisible) {
                return subList.length === colorList.length && subList.every((value, index) => {
                    if (colorList[index] === 'Unsure' || colorList[index] === 'Not Visible') {
                        return true;
                    }
                    const lowerValue = value?.toLowerCase() ?? null;
                    const lowerColor = colorList[index]?.toLowerCase() ?? null;
                    return lowerValue === lowerColor;
                });
            } else {
                return subList.length === colorList.length && subList.every((value, index) => {
                    const lowerValue = value?.toLowerCase() ?? null;
                    const lowerColor = colorList[index]?.toLowerCase() ?? null;
                    return lowerValue === lowerColor;
                });
            };
        });
        return isContained;
    }

    const checkBandedColors = () => {
        setBandedWarning('');
        var warningMsg = '';
        for (let i = 1; i <= selectedPhoto.num; i++) {
            const colorContent = {
                leftLower: gspStates[i - 1].leftLower,
                leftUpper: gspStates[i - 1].leftUpper,
                rightLower: gspStates[i - 1].rightLower,
                rightUpper: gspStates[i - 1].rightUpper,
            };
            if (!isBandedColorCorrect(colorContent)) {
                if (warningMsg.length === 0) {
                    warningMsg = 'parrot ' + String(i);
                } else {
                    warningMsg = warningMsg + ', parrot ' + String(i);
                }
            }
        }
        setBandedWarning(warningMsg);
        if (warningMsg.length === 0) {
            return false;
        } else {
            return true;
        }
    }

    // Update the saveHandleClick function similarly
    const saveHandleClick = () => {
        setSaving(true);
        clearWarning();
        if (checkButtonClicked()) {
            setSaving(false);
            return;
        }

        const checkRst = checkBandedColors();
        if (checkRst) {
            setShowBandedWarning(true);
        } else {
            const submitData = generateLabelData();

            validateapi.save(submitData)
                .then((body) => {
                    if (body === undefined || body === null) {
                        // Handle case when server doesn't return a body
                        message.error('No response from server. Please try again later.');
                        setSaving(false);
                        return;
                    }

                    if (body == true) {
                        // Update the current photo's validateFlag in the data array
                        // Use "Y" instead of "P" to show a checkmark
                        const updatedData = data.map(item => {
                            if (item.photoId === selectedPhoto.photoId) {
                                return { ...item, validateFlag: "Y" };
                            }
                            return item;
                        });
                        setData(updatedData);

                        // 检查是否还有未标注的照片
                        const pendingPhotos = updatedData.filter(item => item.validateFlag !== "Y");
                        if (pendingPhotos.length === 0) {
                            // 如果所有照片都已标注，清空选中的照片和相关状态
                            setSelectedPhoto(null);
                            currentPhoto = null;
                            setTableData([]);
                            setShowLabelling(false);
                            setSaving(false); // 重置saving状态
                            return;
                        }

                        handleArrowClick('right');
                        clearButton(true);
                        setSaving(false);
                        //解锁逻辑
                        unlockPhoto();
                        return;
                    } else {
                        setSubmitTitle('Error');
                        setSubmit('This image has been validated by others, please label other images.');
                        setIsModalOpen(true);
                        handleArrowClick('right');
                        clearButton(true);
                        setSaving(false);
                    }
                })
                .catch(() => {
                    setSubmitTitle('Error');
                    setSubmit('Save failed, please try again.');
                    setIsModalOpen(true);
                    setSaving(false);
                });

            // Store a simplified version without circular references
            const simplifiedPhoto = {
                fileName: selectedPhoto.fileName,
                validateFlag: "Y", // Set to "Y" to match the UI update
                hasAnimal: selectedPhoto.hasAnimal,
                visibleNum: 100,
                num: selectedPhoto.num,
                comments: comments
            };
            savedPhotoDict[selectedPhoto.fileName] = [simplifiedPhoto,
                JSON.parse(JSON.stringify(buttonStates)),
                JSON.parse(JSON.stringify(gspStates)),
                "wrong"];
        }
    };

    const generateLabelData = () => {
        const animalMarkResultList = [];

        if (selectedPhoto.hasAnimal === 'N') {
            // If there are no animals, just add a simple entry
            const labelData = {
                projectId: 1
            };
            const labelContent = {
                visibleNum: 100,
                comments: comments
            };
            labelData.projectCharactersJson = JSON.stringify(labelContent);
            animalMarkResultList.push(labelData);
        } else {
            // If there are no banded animals (num === 0)
            if (selectedPhoto.num === 0 || bandedNum === 0) {
                const labelData = {
                    projectId: 1
                };
                const labelContent = {
                    visibleNum: visibleNum !== undefined ? visibleNum : 100,
                    comments: comments
                };
                labelData.projectCharactersJson = JSON.stringify(labelContent);
                animalMarkResultList.push(labelData);
            }

            // For each banded animal
            for (let i = 1; i <= bandedNum; i++) {
                const labelData = {
                    projectId: 1
                };
                const labelContent = {
                    visibleNum: visibleNum !== undefined ? visibleNum : 100,
                    sex: gspStates[i - 1].sex,
                    age: gspStates[i - 1].age,
                    banded: 'Y',
                    leftLower: gspStates[i - 1].leftLower,
                    leftUpper: gspStates[i - 1].leftUpper,
                    rightLower: gspStates[i - 1].rightLower,
                    rightUpper: gspStates[i - 1].rightUpper,
                    comments: comments
                };
                labelData.projectCharactersJson = JSON.stringify(labelContent);
                animalMarkResultList.push(labelData);
            }
        }

        return {
            photoId: selectedPhoto.photoId,
            userId: globalInfo.user.userId,
            markStatus: 'L',
            hasAnimal: gspActiveButton === 'button_in_y' ? 'Y' : 'N',
            visibleNum: 100,
            num: bandedNum,
            validateFlag: "Y", // Set this to "Y" to indicate validation is complete
            comments: comments,
            animalMarkResultList: animalMarkResultList
        };
    }

    const generateCorrectLabelData = () => {
        const submitData = {
            photoId: selectedPhoto.photoId,
            userId: globalInfo.user.userId,
            markStatus: selectedPhoto.markStatus,
            hasAnimal: selectedPhoto.hasAnimal,
            validateFlag: "Y",
            animalMarkResultList: selectedPhoto.animalMarkResultList,
        }
        selectedPhoto.validateFlag = "Y"
        return submitData;
    }

    const clearVisibleButton = (value) => {
        if (value > 3) {
            setGspVisibleButton(null);
        } else {
            setGspVisibleButton('button_num_' + value);
        }
        setVisibleNum(value);
        if (selectedPhoto) {
            selectedPhoto.visibleNum = value;
            if (value < bandedNum) {
                setBandedNum(0);
                gspNumHandleClick('button_num_0', 0);
            }
        }
    }

    const clearBandedButton = (value) => {
        if (value > visibleNum) {
            value = visibleNum
        }
        gspNumHandleClick('button_num_' + value, value);
        setBandedNum(value);
    }

    const handleRightUpperChange = (value, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].rightUpper = value.value;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].rightUpper = value.label[1];
            return newState;
        });
    };

    const handleRightLowerChange = (value, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].rightLower = value.value;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].rightLower = value.label[1];
            return newState;
        });
    };

    const handleLeftUpperChange = (value, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].leftUpper = value.value;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].leftUpper = value.label[1];
            return newState;
        });
    };

    const handleLeftLowerChange = (value, index) => {
        setButtonStates((prevState) => {
            const newState = [...prevState];
            newState[index].leftLower = value.value;
            return newState;
        });

        setGspStates((prevState) => {
            const newState = [...prevState];
            newState[index].leftLower = value.label[1];
            return newState;
        });
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleArrowClick = (direction) => {
        // 获取未标注的照片列表
        const pendingPhotos = data.filter(item => item.validateFlag !== "Y");

        if (pendingPhotos.length === 0) {
            // 如果所有照片都已标注，清空选中的照片和相关状态
            setSelectedPhoto(null);
            currentPhoto = null;
            setTableData([]);
            setShowLabelling(false);
            return;
        }

        if (direction === 'left' && selectedPhotoIndex > 0) {
            //判断上一张照片是否上锁
            const leftPhoto = data.slice(0, selectedPhotoIndex)
                .reverse()
                .find(photo => checkPhotoLock(photo.photoId));
            if (leftPhoto) {
                const leftPhotoIndex = data.indexOf(leftPhoto);
                const prevPhoto = leftPhoto;
                setSelectedPhoto(prevPhoto);
                setSelectedPhotoIndex(leftPhotoIndex);
                currentPhoto = prevPhoto;
                if (scrollableTarget) {
                    scrollableTarget.scrollTop = (leftPhotoIndex) * 213;
                }
                if (prevPhoto && !(prevPhoto.fileName in savedPhotoDict) && !prevPhoto.hasAnimal) {
                    prevPhoto.hasAnimal = 'N';
                }
                clearButton(true);
                lockPhoto(prevPhoto.photoId);
            } else {
                message.warning("Reached the top");
            }
        } else if (direction === 'right' && selectedPhotoIndex < data.length - 1) {
            const rightPhoto = data.slice(selectedPhotoIndex + 1)
                .find(photo => checkPhotoLock(photo.photoId));
            if (rightPhoto) {
                const rightPhotoIndex = data.indexOf(rightPhoto);
                if (scrollableTarget) {
                    scrollableTarget.scrollTop = selectedPhotoIndex * 213;
                }

                // 找到下一张未标注的照片
                let nextPhotoIndex = rightPhotoIndex;
                let nextPhoto = data[nextPhotoIndex];

                // 如果下一张照片已经标注完成，继续寻找未标注的照片
                while (nextPhoto && nextPhoto.validateFlag === "Y" && nextPhotoIndex < data.length - 1) {
                    nextPhotoIndex++;
                    nextPhoto = data[nextPhotoIndex];
                }

                // 如果找不到未标注的照片，清空选中的照片
                if (!nextPhoto || nextPhoto.validateFlag === "Y") {
                    setSelectedPhoto(null);
                    currentPhoto = null;
                    setTableData([]);
                    setShowLabelling(false);
                    return;
                }

                setSelectedPhoto(nextPhoto);
                setSelectedPhotoIndex(nextPhotoIndex);
                currentPhoto = nextPhoto;
                if (nextPhoto && !(nextPhoto.fileName in savedPhotoDict) && !nextPhoto.hasAnimal) {
                    nextPhoto.hasAnimal = 'N';
                }
                clearButton(true);
                lockPhoto(nextPhoto.photoId);
            } else {
                message.warning("End of the list");
            }

        }
        setShowLabelling(false);
        setShowBandedWarning(false);
        scrollToTop("label-sider");
        getTableData(currentPhoto);
    };

    const showSavedPhoto = () => {
        if (currentPhoto != null && currentPhoto.fileName in savedPhotoDict) {
            setButton(savedPhotoDict[currentPhoto.fileName]);
        }
        if (currentPhoto) {
            setSelectedPhoto(currentPhoto);
        }
        clearWarning();
    }

    const showAgeExamples = () => {
        setIsShowAgeExamples(true);
    }

    const showBandedExamples = () => {
        setIsShowBandedExamples(true);
    }

    const closeShowAgeExamples = () => {
        setIsShowAgeExamples(false);
    }

    const closeShowBandedExamples = () => {
        setIsShowBandedExamples(false);
    }

    // Update the closeBandedWaring_yes function similarly
    const closeBandedWaring_yes = () => {
        setShowBandedWarning(false);

        validateapi.save(generateLabelData())
            .then((body) => {
                if (body === undefined || body === null) {
                    // Handle case when server doesn't return a body
                    message.error('No response from server. Please try again later.');
                    setSaving(false);
                    return;
                }

                if (body == true) {
                    // Update the current photo's validateFlag in the data array
                    // Use "Y" instead of "P" to show a checkmark
                    const updatedData = data.map(item => {
                        if (item.photoId === selectedPhoto.photoId) {
                            return { ...item, validateFlag: "Y" };
                        }
                        return item;
                    });
                    setData(updatedData);

                    // 检查是否还有未标注的照片
                    const pendingPhotos = updatedData.filter(item => item.validateFlag !== "Y");
                    if (pendingPhotos.length === 0) {
                        // 如果所有照片都已标注，清空选中的照片和相关状态
                        setSelectedPhoto(null);
                        currentPhoto = null;
                        setTableData([]);
                        setShowLabelling(false);
                        setSaving(false); // 重置saving状态
                        return;
                    }

                    handleArrowClick('right');
                    clearButton(true);
                    setSaving(false);
                    return;
                } else {
                    setSubmitTitle('Error');
                    setSubmit('This image has been validated by others, please label other images.');
                    setIsModalOpen(true);
                    handleArrowClick('right');
                    clearButton(true);
                    setSaving(false);
                }
            })
            .catch(() => {
                setSubmitTitle('Error');
                setSubmit('Save failed, please try again.');
                setIsModalOpen(true);
                setSaving(false);
            });

        // Store a simplified version without circular references
        const simplifiedPhoto = {
            fileName: selectedPhoto.fileName,
            validateFlag: "Y", // Set to "Y" to match the UI update
            hasAnimal: selectedPhoto.hasAnimal,
            visibleNum: selectedPhoto.visibleNum,
            num: selectedPhoto.num,
            comments: comments
        };
        savedPhotoDict[selectedPhoto.fileName] = [simplifiedPhoto,
            JSON.parse(JSON.stringify(buttonStates)),
            JSON.parse(JSON.stringify(gspStates)),
            "wrong"];
    }

    const saveCorrectAnswer = (labellerIndex) => {
        selectedLabeller[selectedPhoto.fileName] = labellerIndex
        setShowBandedWarning(false);

        // Get the selected labeller's data
        const selectedLabelling = selectedPhoto.allLabellings[labellerIndex];

        // Create submission data with the selected labeller's results
        const submitData = {
            photoId: selectedPhoto.photoId,
            userId: globalInfo.user.userId,
            markStatus: 'L',
            hasAnimal: selectedLabelling.hasAnimal,
            validateFlag: "Y",
            // Make a deep copy of the animalMarkResultList to avoid circular references
            animalMarkResultList: JSON.parse(JSON.stringify(selectedLabelling.animalMarkResultList || [])),
            supportedLabellerId: selectedLabelling.userId // Add the ID of the labeller being supported
        };

        // If hasAnimal is "N", ensure projectId is set to 1
        if (selectedLabelling.hasAnimal === 'N') {
            // Check if animalMarkResultList exists and has items
            if (!submitData.animalMarkResultList || submitData.animalMarkResultList.length === 0) {
                // Create a new entry with projectId 1
                submitData.animalMarkResultList = [{
                    projectId: 1,
                    projectCharactersJson: JSON.stringify({
                        visibleNum: 100,
                        comments: selectedLabelling.comments || ''
                    })
                }];
            } else {
                // Ensure each item in the list has projectId set to 1
                submitData.animalMarkResultList.forEach(item => {
                    item.projectId = 1;
                });
            }
        }

        validateapi.save(submitData)
            .then((body) => {
                if (body == true) {
                    // Update the current photo's validateFlag in the data array
                    const updatedData = data.map(item => {
                        if (item.photoId === selectedPhoto.photoId) {
                            return { ...item, validateFlag: "Y" };
                        }
                        return item;
                    });
                    setData(updatedData);

                    // 检查是否还有未标注的照片
                    const pendingPhotos = updatedData.filter(item => item.validateFlag !== "Y");
                    if (pendingPhotos.length === 0) {
                        // 如果所有照片都已标注，清空选中的照片和相关状态
                        setSelectedPhoto(null);
                        currentPhoto = null;
                        setTableData([]);
                        setShowLabelling(false);
                        setSaving(false); // 重置saving状态
                        return;
                    }

                    handleArrowClick('right');
                    clearButton(true);
                    setSaving(false);
                    return;
                } else {
                    setSubmitTitle('Error');
                    setSubmit('This image has been labelled by others, please label other images.');
                    setIsModalOpen(true);
                    handleArrowClick('right');
                    clearButton(true);
                    setSaving(false);
                }
            })
            .catch(() => {
                setSubmitTitle('Error');
                setSubmit('Save failed, please try again.');
                setIsModalOpen(true);
                setSaving(false);
            });

        // Store a simplified version without circular references
        const simplifiedPhoto = {
            fileName: selectedPhoto.fileName,
            validateFlag: "Y"
        };
        savedPhotoDict[selectedPhoto.fileName] = [simplifiedPhoto, [], [], "correct"];
    }

    const closeBandedWaring_no = () => {
        setShowBandedWarning(false);
        setSaving(false);
    }

    const setExamplesAge_f = () => {
        setAgeExamplesSex('f');
    }

    const setExamplesAge_m = () => {
        setAgeExamplesSex('m');
    }

    const { Option } = Select;
    const { TextArea } = Input;

    // Helper function to check if there are differences in a column
    const hasDifferencesInColumn = (data, columnKey) => {
        if (!data || data.length <= 1) return false;

        // Get all values in the column, excluding '-'
        const values = data
            .map(item => item[columnKey])
            .filter(value => value !== '-');

        // If there's only one unique value or no values, there are no differences
        if (new Set(values).size <= 1) return false;

        // There are at least two different values
        return true;
    };

    const fle_example1 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_fle/1.JPG`
    const fle_example2 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_fle/2.JPG`
    const fle_example3 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_fle/3.JPG`

    const juv_example1 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_juv/1.JPG`
    const juv_example2 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_juv/2.JPG`
    const juv_example3 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_juv/3.JPG`

    const adu_example1 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_adu/1.JPG`
    const adu_example2 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_adu/2.JPG`
    const adu_example3 = `/img/age_examples/${ageExamplesSex}/${ageExamplesSex}_adu/3.JPG`

    const getTableData = (currentPhoto) => {
        let data = []
        if (!currentPhoto) {
            setTableData([]);
            return;
        }

        if (!currentPhoto.allLabellings || currentPhoto.allLabellings.length === 0) {
            // Handle case where data isn't in expected format
            data = [
                {
                    key: '1',
                    date: currentPhoto?.labellingDate || '-',
                    hasGSP: currentPhoto?.hasAnimal || '-',
                    visible: '-',
                    sex: '-',
                    age: '-',
                    RU: '-',
                    RL: '-',
                    LU: '-',
                    LL: '-',
                    LB: '-',
                    Comments: '-'
                }
            ];
        } else {
            // 处理所有标注者的数据
            currentPhoto.allLabellings.forEach((labelling, index) => {
                if (!labelling) return; // Skip if labelling is null

                if (labelling.animalMarkResultList && labelling.animalMarkResultList.length > 0) {
                    labelling.animalMarkResultList.forEach((result, resultIndex) => {
                        try {
                            const parsedData = JSON.parse(result.projectCharactersJson || '{}');

                            // 获取对应字段的值
                            const visible = parsedData.visibleNum || '-';
                            const hasGSP = labelling.hasAnimal || '-';
                            const sex = parsedData.sex || '-';
                            const age = parsedData.age || '-';
                            const RU = parsedData.rightUpper || "None";
                            const RL = parsedData.rightLower || "None";
                            const LU = parsedData.leftUpper || "None";
                            const LL = parsedData.leftLower || "None";
                            const Comments = parsedData.comments || '-';

                            // Remove differences calculation code - we'll use hasDifferencesInColumn instead

                            data.push({
                                key: `${index}-${resultIndex}`,
                                date: labelling.labellingDate ? labelling.labellingDate.split("T")[0] : '-',
                                visible,
                                hasGSP,
                                sex,
                                age,
                                RU,
                                RL,
                                LU,
                                LL,
                                LB: labelling.markedBy || '-',
                                Comments
                            });
                        } catch (e) {
                            console.error("Error parsing JSON:", e);
                            // Still add a row even if JSON parsing fails
                            data.push({
                                key: `${index}-${resultIndex}`,
                                date: labelling.labellingDate ? labelling.labellingDate.split("T")[0] : '-',
                                visible: '-',
                                hasGSP: labelling.hasAnimal || '-',
                                sex: '-',
                                age: '-',
                                RU: '-',
                                RL: '-',
                                LU: '-',
                                LL: '-',
                                LB: labelling.markedBy || '-',
                                Comments: '-'
                            });
                        }
                    });
                } else {
                    // Add a row for labellings without animalMarkResultList
                    data.push({
                        key: `${index}-0`,
                        date: labelling.labellingDate ? labelling.labellingDate.split("T")[0] : '-',
                        visible: '-',
                        hasGSP: labelling.hasAnimal || '-',
                        sex: '-',
                        age: '-',
                        RU: '-',
                        RL: '-',
                        LU: '-',
                        LL: '-',
                        LB: labelling.markedBy || '-',
                        Comments: '-'
                    });
                }
            });
        }
        setTableData(data);
    }

    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            key: 'date',
            className: 'val-table'
        },
        //   {
        //     title: 'Visible',
        //     dataIndex: 'visible',
        //     key: 'visible',
        //     className: 'val-table',
        //     render: (text, record) => (
        //       <span style={{ 
        //         fontWeight: hasDifferencesInColumn(tableData, 'visible') ? 'bold' : 'normal',
        //         color: hasDifferencesInColumn(tableData, 'visible') ? 'red' : 'inherit' 
        //       }}>
        //         {text}
        //       </span>
        //     )
        //   },
        {
            title: 'Y/N',
            dataIndex: 'hasGSP',
            key: 'hasGSP',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'hasGSP') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    color: hasDifferencesInColumn(tableData, 'hasGSP') ? 'red' : 'inherit'  // disable color because there is only one user's labelling result
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'Sex',
            dataIndex: 'sex',
            key: 'sex',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'sex') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'sex') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'Age',
            dataIndex: 'age',
            key: 'age',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'age') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'age') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'RU',
            dataIndex: 'RU',
            key: 'RU',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'RU') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'RU') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'RL',
            dataIndex: 'RL',
            key: 'RL',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'RL') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'RL') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'LU',
            dataIndex: 'LU',
            key: 'LU',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'LU') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'LU') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'LL',
            dataIndex: 'LL',
            key: 'LL',
            className: 'val-table',
            render: (text, record) => (
                <span style={{
                    // fontWeight: hasDifferencesInColumn(tableData, 'LL') ? 'bold' : 'normal',
                    fontWeight: 'normal',
                    // color: hasDifferencesInColumn(tableData, 'LL') ? 'red' : 'inherit' 
                }}>
                    {text}
                </span>
            )
        },
        {
            title: 'Labelled By',
            dataIndex: 'LB',
            key: 'LB',
            className: 'val-table'
        },
        {
            title: 'Comments',
            dataIndex: 'Comments',
            key: 'Comments',
            className: 'val-table'
        },
    ];

    const ageExamplesPage = () => {
        return (
            <>
                <Flex className='age_examples' vertical='vertical' style={{ marginTop: '20px' }}>
                    <Flex >
                        <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            <p>Fle</p>
                        </div>
                        <Image className='age_examples_img' src={fle_example1} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={fle_example2} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={fle_example3} style={{ width: '120px' }} />
                    </Flex>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <Flex >
                        <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            <p>Juv</p>
                        </div>
                        <Image className='age_examples_img' src={juv_example1} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={juv_example2} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={juv_example3} style={{ width: '120px' }} />
                    </Flex>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <Flex >
                        <div style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                            <p>Adu</p>
                        </div>
                        <Image className='age_examples_img' src={adu_example1} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={adu_example2} style={{ width: '120px' }} />
                        <Image className='age_examples_img' src={adu_example3} style={{ width: '120px' }} />
                    </Flex>
                </Flex>
            </>
        )
    }

    const approximateAgeContent = (num, handleClick, index) => {
        const ageId = `GSP-age${num}`
        let warning;
        if (warningList.includes(ageId)) {
            warning = true;
        } else {
            warning = false;
        }
        if (buttonStates.length === bandedNum) {
            return (
                <>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <div id={ageId} style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        borderRadius: '10px',
                        border: warning ? '1px solid red' : 'none'
                    }}>
                        <div className={'labelling-content'}>
                            What is the approx age of parrot {num}?
                            <QuestionCircleOutlined className={'sex-age-examples-icon'} style={{ marginLeft: "6px", fontSize: '17px' }} onClick={showAgeExamples} />
                        </div>
                        <div style={{
                            display: 'flex',
                            gap: '8px',
                            margin: '0 20px'
                        }}>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].age === ('button_age_fle' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 55,
                                alignItems: 'center'
                            }}
                                onClick={() => handleClick('button_age_fle' + num, 'fle', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                fle
                            </Button>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].age === ('button_age_juv' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 55
                            }}
                                onClick={() => handleClick('button_age_juv' + num, 'juv', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                juv
                            </Button>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].age === ('button_age_adu' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 55
                            }}
                                onClick={() => handleClick('button_age_adu' + num, 'adu', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                adu
                            </Button>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].age === ('button_age_unknown' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 90,
                                alignItems: 'center'
                            }}
                                onClick={() => handleClick('button_age_unknown' + num, 'unknown', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                unknown
                            </Button>
                            <Modal
                                title='Age Examples'
                                open={isShowAgeExamples}
                                onOk={closeShowAgeExamples}
                                onCancel={closeShowAgeExamples}
                                footer={[
                                    <Button key="showAgeExamples" type="primary" onClick={closeShowAgeExamples}>
                                        OK
                                    </Button>,
                                ]}>
                                <Button key="showAgeExamples_m"
                                    type={ageExamplesSex === 'm' ? 'primary' : 'default'}
                                    onClick={setExamplesAge_m}
                                    style={{ width: '50px', borderRadius: '0' }}>
                                    M
                                </Button>
                                <Button key="showAgeExamples_f"
                                    type={ageExamplesSex === 'f' ? 'primary' : 'default'}
                                    onClick={setExamplesAge_f}
                                    style={{ width: '50px', borderRadius: '0' }}>
                                    F
                                </Button>
                                {ageExamplesPage()}
                            </Modal>
                        </div>
                    </div>
                </>
            )
        }
    }

    const sexContent = (num, handleClick, index) => {
        const sexId = `GSP-sex${num}`
        let warning;
        if (warningList.includes(sexId)) {
            warning = true;
        } else {
            warning = false;
        }
        if (buttonStates.length === bandedNum) {
            return (
                <>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <div id={sexId} style={{
                        paddingTop: '10px',
                        paddingBottom: '10px',
                        borderRadius: '10px',
                        border: warning ? '1px solid red' : 'none'
                    }}>
                        <div className={'labelling-content'}>
                            Of BANDED GSP, what is the sex of parrot {num}?
                            <QuestionCircleOutlined className={'sex-age-examples-icon'} style={{ marginLeft: "6px", fontSize: '17px' }} onClick={showAgeExamples} />
                        </div>
                        <div style={{
                            display: 'flex',
                            gap: '20px',
                            margin: '0 20px'
                        }}>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].sex === ('button_sex_m' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 60
                            }}
                                onClick={() => handleClick('button_sex_m' + num, 'm', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                M
                            </Button>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].sex === ('button_sex_f' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 60
                            }}
                                onClick={() => handleClick('button_sex_f' + num, 'f', index)}
                                disabled={((gspActiveButton === 'button_in_y' & bandedNum !== 0) & bandedNum !== 0) ? false : true} >
                                F
                            </Button>
                            <Button style={{
                                backgroundColor: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? (buttonStates[index].sex === ('button_sex_unknown' + num) ? '#a5c7ff' : '#e0e0e0') : null,
                                color: (gspActiveButton === 'button_in_y' & bandedNum !== 0) ? 'black' : null,
                                width: 90
                            }}
                                onClick={() => handleClick('button_sex_unknown' + num, 'unknown', index)}
                                disabled={(gspActiveButton === 'button_in_y' & bandedNum !== 0) ? false : true} >
                                unknown
                            </Button>
                        </div>
                    </div>
                </>
            )
        }
    }

    function toCamelCase(str) {
        return str
            .split(' ')
            .map((word, index) => {
                return index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            })
            .join('');
    }

    const chooseColor = (handleChange, colorOptions, name, index) => {
        if (buttonStates.length === bandedNum) {
            let value;
            if (buttonStates.length === 0 || buttonStates[index][`${toCamelCase(name)}`] === null) {
                value = leftLowerColorOptions[0].value[0] + leftLowerColorOptions[0].value[1];
            } else {
                value = buttonStates[index][`${toCamelCase(name)}`];
            }
            return (
                <>
                    <div className={'labelling-color'} style={{
                        display: 'flex', alignItems: 'center', marginTop: '5px', marginBottom: '5px', marginLeft: '20px', marginRight: '20px'
                    }}>
                        <div style={{ marginRight: '16px', alignSelf: 'center', width: '100px' }}>{name}</div>
                        <Select
                            defaultValue={leftLowerColorOptions[0].value[0] + leftLowerColorOptions[0].value[1]} // 设置默认值
                            value={value}
                            style={{ width: 150 }}
                            onChange={(e) => handleChange(e, index)}
                            labelInValue
                            disabled={gspActiveButton !== 'button_in_y' | bandedNum === 0 ? true : false}
                        >
                            {colorOptions.map((color) => (
                                <Option key={color.label} value={color.value[0] + color.value[1]}>
                                    <div style={{
                                        marginRight: '8px',
                                        lineHeight: '20px',
                                        display: 'inline-block',
                                        verticalAlign: 'middle',
                                        marginBottom: '3px',
                                        border: color.label !== 'None'
                                            && color.label !== 'Unsure'
                                            && color.label !== 'Not Visible' ? '1px solid black' : 'none',
                                    }}>
                                        <div
                                            style={{
                                                backgroundColor: color.value[0],
                                                width: '20px',
                                                height: '10px',
                                            }} />
                                        <div
                                            style={{
                                                backgroundColor: color.value[1],
                                                width: '20px',
                                                height: '10px',
                                            }} />
                                    </div>
                                    {color.label}
                                </Option>
                            ))}
                        </Select>
                    </div>
                </>
            )
        }
    }

    const colorContent = (num, handleRightUpperChange, handleRightLowerChange, handleLeftUpperChange,
        handleLeftLowerChange, index) => {
        if (buttonStates.length === bandedNum) {
            return (
                <>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                    <div style={{
                        paddingTop: '10px',
                        paddingBottom: '10px'
                    }}>
                        <div className={'labelling-content'} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            Parrot {num} Band Colour:
                            <QuestionCircleOutlined className={'sex-age-examples-icon'} style={{ marginLeft: "6px", fontSize: '17px' }} onClick={showBandedExamples} />
                        </div>
                        {chooseColor(handleRightUpperChange, rightUpperColorOptions, "Right Upper", index)}
                        {chooseColor(handleRightLowerChange, rightLowerColorOptions, "Right Lower", index)}
                        {chooseColor(handleLeftUpperChange, leftUpperColorOptions, "Left Upper", index)}
                        {chooseColor(handleLeftLowerChange, leftLowerColorOptions, "Left Lower", index)}
                    </div>
                    <Modal
                        title='Band Examples'
                        open={isShowBandedExamples}
                        onOk={closeShowBandedExamples}
                        onCancel={closeShowBandedExamples}
                        width={900}
                        footer={[
                            <Button key="showAgeExamples" type="primary" onClick={closeShowBandedExamples}>
                                OK
                            </Button>,
                        ]}>
                        <Flex >
                            <Image className='age_examples_img' src='/img/band_examples/left_right.jpg' />
                            <Image className='age_examples_img' src='/img/band_examples/banding_code.jpg' />
                        </Flex>
                    </Modal>
                    <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                </>
            )
        }
    }

    const renderAdditionalContent = () => {
        return Array.from({ length: bandedNum - 1 }, (_, index) => (
            <React.Fragment key={index}>
                {sexContent((index + 2).toString(), gspSexHandleClick, index + 1)}
                {approximateAgeContent((index + 2).toString(), gspAgeHandleClick, index + 1)}
                {colorContent((index + 2).toString(), handleRightUpperChange, handleRightLowerChange,
                    handleLeftUpperChange, handleLeftLowerChange, index + 1)}
            </React.Fragment>
        ));
    };

    return (
        <ConfigProvider locale={en_GB}>
            {globalInfo.user.userRole && (
                <GlobalInfoProvider>
                    <>
                        <Layout style={{ height: '100%' }}>
                            <Header onLogoClick={goHomePage} />
                            <Layout >
                                <Sider width={320} style={{ background: 'white', height: '100%' }} collapsed={collapsed} className='min-h-80'>
                                    <div className={"sider-left"}>
                                        <div
                                            id="scrollableDiv"
                                            ref={(ref) => setScrollableTarget(ref)}
                                            style={{
                                                height: "100%",
                                                overflow: 'auto',
                                                padding: '0 20px',
                                                borderRadius: '10px',
                                                backgroundColor: 'white',
                                            }}
                                        >
                                            <InfiniteScroll
                                                dataLength={data.length}
                                                next={loadMoreData}
                                                hasMore={data.length < imageNum}
                                                loader={<Skeleton.Image paragraph={{ rows: 1 }} active />}
                                                endMessage={<Divider plain>It is all, nothing more 🤐</Divider>}
                                                scrollableTarget="scrollableDiv"
                                            >
                                                <List
                                                    dataSource={data}
                                                    renderItem={(item, index) => (
                                                        <Tooltip title={!checkPhotoLock(item.photoId) ? "The photo is being operated by someone else or has already been labelled by others." : ""} placement="top">
                                                            <List.Item key={item.photoId} onClick={() => {

                                                                if (!checkPhotoLock(item.photoId)) return; // 如果被锁定，点击无效
                                                                handlePhotoClick(item);
                                                                setSelectedPhotoIndex(index);
                                                            }}
                                                                className={!checkPhotoLock(item.photoId) ? 'list-item-locked' : ''}
                                                            >
                                                                <div id={'list-item'} style={{ width: '264px', position: 'relative' }}>
                                                                    <div className={`image-container ${selectedPhotoIndex === index ? 'selected' : ''}`}>
                                                                        <img width={256} alt="images" src={BASE_URL + item.fileUrl} />
                                                                        {item.validateFlag === "Y" && (
                                                                            <div className="labelled-marker-marked">
                                                                                <CheckOutlined style={{ fontSize: '13px', fontWeight: 'bold', color: 'white' }} />
                                                                            </div>
                                                                        )}
                                                                        {item.validateFlag === 'P' && (
                                                                            <div className="labelled-marker-mark-failed">
                                                                                <ExclamationCircleOutlined style={{ fontSize: '13px', fontWeight: 'bold', color: 'white' }} />
                                                                            </div>
                                                                        )}
                                                                        {/* 显示锁图标 */}
                                                                        {!checkPhotoLock(item.photoId) && (
                                                                            <div className="lock-overlay-sider">🔒</div>
                                                                        )}
                                                                    </div>
                                                                    <div style={{ wordWrap: 'break-word' }}>{item.fileName}</div>
                                                                </div>
                                                            </List.Item>
                                                        </Tooltip>

                                                    )} />
                                            </InfiniteScroll>
                                        </div>
                                    </div>
                                </Sider>
                                <Layout >
                                    <Content style={{ background: '#e0e0e0', paddingTop: '8px', paddingBlock: '8px', paddingLeft: '4px', paddingRight: '4px' }} >
                                        <div className={"imageContent-val"}>
                                            {selectedPhoto ? (
                                                <>
                                                    <div id="label-result" style={{ width: "100%", maxHeight: "40%", overflowY: "auto" }}>
                                                        <Table
                                                            size="small"
                                                            pagination={false}
                                                            dataSource={tableData} columns={columns} />
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: '100%',
                                                            height: 'calc(60% - 10px)',
                                                            display: 'flex',
                                                            justifyContent: 'center', // 水平居中
                                                            alignItems: 'center', // 垂直居中
                                                            margin: '10px 0',
                                                            overflow: 'hidden' // 防止内容溢出（可选）
                                                        }}
                                                    >
                                                        <div style={{
                                                            width: '100%',
                                                            height: '100%',
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            alignItems: 'center'
                                                        }}>
                                                            <Image
                                                                height={"100%"}
                                                                preview={true}
                                                                alt="selected-image"
                                                                src={BASE_URL + selectedPhoto.fileUrl} />
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        textAlign: 'center',
                                                        marginTop: '10px',
                                                        height: "5%",
                                                        position: 'relative',
                                                        bottom: 0
                                                    }}>
                                                        <Button size="large" type="primary" shape="circle" icon={<ArrowLeftOutlined />} onClick={() => handleArrowClick('left')} />
                                                        <span style={{ marginRight: '18px' }}></span>
                                                        {selectedPhoto.fileName}
                                                        <span style={{ marginLeft: '18px' }}></span>
                                                        <Button size="large" type="primary" shape="circle" icon={<ArrowRightOutlined />} onClick={() => handleArrowClick('right')} />
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                                    <div style={{ fontSize: '18px', marginBottom: '20px' }}>
                                                        All photos have been validated!
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </Content>
                                </Layout>
                                <Sider width={320} style={{ background: 'white', height: '100%' }} collapsed={collapsed} className='min-h-80' >
                                    <div className={'sider-right'}>
                                        <div style={{ height: '100%', background: 'white', borderRadius: '10px' }}>
                                            {selectedPhoto ? (
                                                <>
                                                    <div id="label-sider" style={{
                                                        height: "95%",
                                                        overflow: 'auto',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'white',
                                                        display: showLabelling ? "none" : ""
                                                    }}>
                                                        <div id="GSP-active" style={{
                                                            paddingTop: '10px',
                                                            paddingBottom: '10px',
                                                            borderRadius: '10px',
                                                        }}>
                                                            <div className={'labelling-content'}>
                                                                Do you agree with the labeling results?
                                                            </div>
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '10px',
                                                                margin: '10px 20px'
                                                            }}>
                                                                {selectedPhoto && selectedPhoto.allLabellings &&
                                                                    selectedPhoto.allLabellings.map((labelling, index) => (
                                                                        <Button
                                                                            key={index}
                                                                            style={{
                                                                                backgroundColor: selectedLabeller[selectedPhoto.fileName] === index ? '#a5c7ff' : '#e0e0e0',
                                                                                color: 'black',
                                                                                width: '100%',
                                                                                textAlign: 'left'
                                                                            }}
                                                                            onClick={() => saveCorrectAnswer(index)}>
                                                                            {/* New change: validateFlag is P for only one user */}
                                                                            {/* {labelling.markedBy || `Labeller ${index+1}`} */}
                                                                            Agree
                                                                        </Button>
                                                                    ))}
                                                                <Button
                                                                    style={{
                                                                        backgroundColor: selectedLabeller[selectedPhoto.fileName] === 'N' ? '#a5c7ff' : '#e0e0e0',
                                                                        color: 'black',
                                                                        width: '100%',
                                                                        textAlign: 'left'
                                                                    }}
                                                                    onClick={() => answerCorrectClick('N')}>
                                                                    Disagree - Label myself
                                                                </Button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div id="label-sider" style={{
                                                        height: "95%",
                                                        overflow: 'auto',
                                                        borderRadius: '10px',
                                                        backgroundColor: 'white',
                                                        display: showLabelling ? "" : "none"
                                                    }}>
                                                        <div className={'labelling-warning'}
                                                            style={{
                                                                display: isShowWarning ? 'flex' : 'none',
                                                            }}>
                                                            <span style={{
                                                                marginTop: '14px',
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            }}>
                                                                <ExclamationCircleOutlined
                                                                    style={{
                                                                        color: 'red',
                                                                        fontSize: '28px',
                                                                        marginRight: '8px'
                                                                    }} />
                                                                Please answer the required questions
                                                            </span>
                                                            <span onClick={jumpToWarning} style={{ marginTop: '8px', marginBottom: '10px', color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}>
                                                                Show Detail
                                                            </span>
                                                        </div>
                                                        <div id="GSP-active" style={{
                                                            paddingTop: '10px',
                                                            paddingBottom: '10px',
                                                            borderRadius: '10px',
                                                            border: isGspActiveButtonWarning ? '1px solid red' : 'none'
                                                        }}>
                                                            <div className={'labelling-content'}>
                                                                Is there any GSP visible in this image?
                                                            </div>
                                                            <div style={{
                                                                display: 'flex',
                                                                gap: '20px',
                                                                margin: '0 20px'
                                                            }}>
                                                                <Button style={{
                                                                    backgroundColor: gspActiveButton === 'button_in_y' ? '#a5c7ff' : '#e0e0e0',
                                                                    color: 'black', width: 60
                                                                }}
                                                                    onClick={() => gspHandleClick('button_in_y', 'Y')} >
                                                                    Yes
                                                                </Button>
                                                                <Button style={{
                                                                    backgroundColor: gspActiveButton === 'button_in_n' ? '#a5c7ff' : '#e0e0e0',
                                                                    color: 'black', width: 60
                                                                }}
                                                                    onClick={() => gspHandleClick('button_in_n', 'N')} >
                                                                    No
                                                                </Button>
                                                            </div>
                                                        </div>
                                                        {/* Remove visible number count */}
                                                        {/* <Divider style={{marginTop: '10px', marginBottom: '10px'}}/>
                                                    <div id="GSP-visible" style={{
                                                            paddingTop: '10px',
                                                            paddingBottom: '10px',
                                                            borderRadius: '10px',
                                                            border: isGspVisibleButtonWarning ? '1px solid red' : 'none'}}>
                                                        <div className={'labelling-content'}>
                                                            How many GSP are visible?
                                                        </div>
                                                        <div style={{
                                                            display: 'flex',
                                                            gap: '20px',
                                                            margin: '0 20px'}}>
                                                            <Button style={{ 
                                                                    backgroundColor: gspActiveButton === 'button_in_y' ? (gspVisibleButton === 'button_num_1' ? '#a5c7ff' : '#e0e0e0') : null, 
                                                                    color: gspActiveButton === 'button_in_y' ? 'black' : null, 
                                                                    width: 60
                                                                }}
                                                                onClick={() => gspVisibleClick('button_num_1', 1)} 
                                                                disabled={gspActiveButton === 'button_in_y' ? false : true} >
                                                                1
                                                            </Button>
                                                            <Button style={{ 
                                                                    backgroundColor: gspActiveButton === 'button_in_y' ? (gspVisibleButton === 'button_num_2' ? '#a5c7ff' : '#e0e0e0') : null, 
                                                                    color: gspActiveButton === 'button_in_y' ? 'black' : null, 
                                                                    width: 60
                                                                }}
                                                                onClick={() => gspVisibleClick('button_num_2', 2)} 
                                                                disabled={gspActiveButton === 'button_in_y' ? false : true} >
                                                                2
                                                            </Button>
                                                            <Button style={{ 
                                                                    backgroundColor: gspActiveButton === 'button_in_y' ? (gspVisibleButton === 'button_num_3' ? '#a5c7ff' : '#e0e0e0') : null, 
                                                                    color: gspActiveButton === 'button_in_y' ? 'black' : null, 
                                                                    width: 60
                                                                }}
                                                                onClick={() => gspVisibleClick('button_num_3', 3)} 
                                                                disabled={gspActiveButton === 'button_in_y' ? false : true} >
                                                                3
                                                            </Button>
                                                            <InputNumber 
                                                                min={1} 
                                                                max={20} 
                                                                controls={true}
                                                                step={1} 
                                                                formatter={value => `${value}`.replace(/\D/g, '')}
                                                                parser={value => parseInt(value || '0', 10)}
                                                                style={{ 
                                                                    width: 80
                                                                }}
                                                                value={visibleNum}
                                                                onChange={clearVisibleButton}
                                                                disabled={gspActiveButton === 'button_in_y' ? false : true} >
                                                                
                                                            </InputNumber>
                                                        </div>
                                                    </div> */}
                                                        <Divider style={{ marginTop: '10px', marginBottom: '10px' }} />
                                                        <div id="GSP-number" style={{
                                                            paddingTop: '10px',
                                                            paddingBottom: '10px',
                                                            borderRadius: '10px',
                                                            border: isGspNumActiveButtonWarning ? '1px solid red' : 'none'
                                                        }}>
                                                            <div className={'labelling-content'}>
                                                                How many BANDED GSP are visible?
                                                            </div>
                                                            <div style={{
                                                                display: 'flex',
                                                                gap: '20px',
                                                                margin: '0 20px'
                                                            }}>
                                                                <Button
                                                                    style={{
                                                                        backgroundColor: gspActiveButton === 'button_in_y' & 0 <= visibleNum ? (gspNumActiveButton === 'button_num_0' ? '#a5c7ff' : '#e0e0e0') : null,
                                                                        color: gspActiveButton === 'button_in_y' & 0 <= visibleNum ? 'black' : null,
                                                                        width: 60
                                                                    }}
                                                                    onClick={() => gspNumHandleClick('button_num_0', 0)}
                                                                    disabled={gspActiveButton === 'button_in_y' & 0 <= visibleNum ? false : true} >
                                                                    0
                                                                </Button>
                                                                <Button
                                                                    style={{
                                                                        backgroundColor: gspActiveButton === 'button_in_y' & 1 <= visibleNum ? (gspNumActiveButton === 'button_num_1' ? '#a5c7ff' : '#e0e0e0') : null,
                                                                        color: gspActiveButton === 'button_in_y' & 1 <= visibleNum ? 'black' : null,
                                                                        width: 60
                                                                    }}
                                                                    onClick={() => gspNumHandleClick('button_num_1', 1)}
                                                                    disabled={gspActiveButton === 'button_in_y' & 1 <= visibleNum ? false : true} >
                                                                    1
                                                                </Button>
                                                                <Button style={{
                                                                    backgroundColor: gspActiveButton === 'button_in_y' & 2 <= visibleNum ? (gspNumActiveButton === 'button_num_2' ? '#a5c7ff' : '#e0e0e0') : null,
                                                                    color: gspActiveButton === 'button_in_y' & 2 <= visibleNum ? 'black' : null,
                                                                    width: 60
                                                                }}
                                                                    onClick={() => gspNumHandleClick('button_num_2', 2)}
                                                                    disabled={gspActiveButton === 'button_in_y' & 2 <= visibleNum ? false : true} >
                                                                    2
                                                                </Button>
                                                                <InputNumber
                                                                    min={0}
                                                                    max={20}
                                                                    controls={true}
                                                                    step={1}
                                                                    formatter={value => `${value}`.replace(/\D/g, '')}
                                                                    parser={value => parseInt(value || '0', 10)}
                                                                    style={{
                                                                        width: 80
                                                                    }}
                                                                    value={bandedNum}
                                                                    onChange={clearBandedButton}
                                                                    disabled={gspActiveButton === 'button_in_y' & 3 <= visibleNum ? false : true} >

                                                                </InputNumber>
                                                            </div>
                                                        </div>
                                                        {sexContent('1', gspSexHandleClick, 0)}
                                                        {approximateAgeContent('1', gspAgeHandleClick, 0)}
                                                        {colorContent('1', handleRightUpperChange, handleRightLowerChange,
                                                            handleLeftUpperChange, handleLeftLowerChange, 0)}

                                                        {renderAdditionalContent()}

                                                        <div style={{
                                                            paddingTop: '10px'
                                                        }}>
                                                            <div className={'labelling-content'}>
                                                                Any additional comments?
                                                            </div>
                                                            <div style={{ margin: '0 20px' }}>
                                                                <TextArea
                                                                    value={comments}
                                                                    onChange={(e) => setComments(e.target.value)}
                                                                    placeholder="Please enter..."
                                                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                                                    style={{ marginBottom: '20px' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div style={{
                                                        height: '5%',
                                                        display: 'flex',
                                                        alignItems: "center",
                                                        justifyContent: 'space-between',
                                                        bottom: '76px',
                                                        backgroundColor: 'white',
                                                        width: '100%',
                                                        borderRadius: '10px',
                                                    }}>
                                                        <Button style={{
                                                            backgroundColor: '#543aff',
                                                            color: 'white', width: "270px", marginBottom: '10px', marginLeft: '20px',
                                                            display: showLabelling ? "" : "none"
                                                        }}
                                                            loading={saving}
                                                            onClick={() => {
                                                                saveHandleClick();
                                                                scrollToTop("label-sider");
                                                            }} >
                                                            SUBMIT
                                                        </Button>
                                                        <Modal
                                                            title={submitTitle}
                                                            open={isModalOpen}
                                                            onOk={handleOk}
                                                            footer={[
                                                                <Button key="ok" type="primary" loading={loading} onClick={handleOk}>
                                                                    OK
                                                                </Button>,
                                                            ]}
                                                        >
                                                            <p>{submit}</p>
                                                        </Modal>
                                                        <Modal
                                                            centered
                                                            title='Warning'
                                                            open={showBandedWarning}
                                                            onCancel={closeBandedWaring_no}
                                                            footer={[
                                                                <Button key="showBandedWarning_yes" type="primary" onClick={closeBandedWaring_yes} style={{ width: '60px' }}>
                                                                    YES
                                                                </Button>,
                                                                <Button key="showBandedWarning_no" onClick={closeBandedWaring_no} style={{ width: '60px' }}>
                                                                    NO
                                                                </Button>,
                                                            ]}>
                                                            <div>
                                                                The system doesn't have the specified leg band color combination of <b>{bandedWarning}</b>. Do you want to proceed with the submission?
                                                            </div>
                                                        </Modal>
                                                    </div>
                                                </>
                                            ) : (
                                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                                    <div style={{ fontSize: '18px', textAlign: 'center', padding: '20px' }}>
                                                        All photos have been validated!
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Sider>
                            </Layout>
                        </Layout>
                    </>
                </GlobalInfoProvider>
            )}
        </ConfigProvider>
    );
};